<template>
  <header id="mainHeader" class="sharkbet-mobile-header" :class="{ 'is-menu-open': menuOpen }">
    <div class="sharkbet-mobile-header__bar">
      <button class="sharkbet-mobile-header__menu" type="button" :aria-expanded="menuOpen"
        @click="menuOpen = !menuOpen">
        <i :class="menuOpen ? 'fas fa-times' : 'fas fa-bars'"></i>
      </button>
      <button class="sharkbet-mobile-header__logo" type="button" aria-label="Inicio" @click="changeView('lobby')">
        <img :src="skin.header_mobil.logo || skin.header_desktop.logo" alt="Sharkbet">
      </button>
      <div v-if="user.token === ''" class="sharkbet-mobile-header__guest">
        <button type="button" @click="openLoginDrawer"><i class="fas fa-user-circle"></i>{{ translate('log_in')
        }}</button>
      </div>
      <div v-else class="sharkbet-mobile-header__member">
        <button type="button" aria-label="Menu de cuenta" :aria-expanded="showAccountDropdown"
          @click.stop="showAccountDropdown = !showAccountDropdown">
          <i class="fas fa-user-circle"></i>
          <span>{{ user.user_data?.data?.user_name || '' }}</span>
          <i class="fas fa-caret-down sharkbet-mobile-header__account-caret"></i>
        </button>
        <div v-if="showAccountDropdown" class="sharkbet-mobile-header__account-dropdown">
          <button type="button" data-bs-toggle="modal" data-bs-target="#sharkbetMyAccount"
            @click="showAccountDropdown = false">Mi cuenta</button>
          <button type="button" @click="logout">Salir</button>
        </div>
      </div>
    </div>

    <nav v-if="menuOpen" class="sharkbet-mobile-nav" aria-label="Navegacion principal">
      <section v-if="user.token !== ''" class="sharkbet-mobile-profile">
        <div class="sharkbet-mobile-profile__identity">
          <i class="fas fa-user-circle" aria-hidden="true"></i>
          <span>{{ user.user_data?.data?.user_name || '' }}</span>
        </div>
        <div class="sharkbet-mobile-profile__balance-row">
          <span>Dinero:</span>
          <strong>{{ currency }} {{ formattedBalance }}</strong>
        </div>
        <div class="sharkbet-mobile-profile__balance-row">
          <span>Bonificacion de Juego:</span>
          <strong>{{ currency }} {{ formattedGameBonus }}</strong>
        </div>
        <div class="sharkbet-mobile-profile__balance-row">
          <span>Bonificacion de sport:</span>
          <strong>{{ currency }} {{ formattedSportsBonus }}</strong>
        </div>
        <button class="sharkbet-mobile-profile__refresh" type="button" :disabled="refreshingProfile"
          @click="refreshProfile">
          <i class="fas fa-sync-alt" :class="{ 'fa-spin': refreshingProfile }" aria-hidden="true"></i>
          {{ refreshingProfile ? 'Actualizando' : 'Actualizar' }}
        </button>
      </section>

      <div class="sharkbet-mobile-nav__tabs" :class="{ 'sharkbet-mobile-nav__tabs--guest': user.token === '' }">
        <button type="button" :class="{ 'is-active': activeMenu === 'main' }" @click="activeMenu = 'main'">MAIN
          MENU</button>
        <button v-if="user.token !== ''" type="button" :class="{ 'is-active': activeMenu === 'user' }"
          @click="activeMenu = 'user'">USER MENU</button>
      </div>

      <div v-if="activeMenu === 'main'" class="sharkbet-mobile-nav__categories">
        <button v-for="item in filteredCategories" :key="item.url" type="button"
          :class="{ 'is-active': isActive(item) }" @click="changeView(item.category); menuOpen = false">
          {{ formatMenuLabel(translate(item.name)) }}
        </button>
      </div>
      <div v-else class="sharkbet-mobile-nav__account">
        <account-menu variant="mobile" :skin="skin" :language="language" :translation="translation"
          @dismiss="menuOpen = false" @logout="logout" />
      </div>
      <footer class="sharkbet-mobile-nav__footer">
        <button v-if="user.token !== ''" type="button" aria-label="Cerrar sesion" @click="logout">
          <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
        </button>
        <label class="sharkbet-mobile-nav__language">
          <span :class="`phoca-flag ${language === 'es' ? 'es' : language === 'en' ? 'gb' : 'br'}`"></span>
          <select :value="language" aria-label="Idioma" @change="changeLanguage($event.target.value)">
            <option v-for="(config, code) in skin.languages" :key="code" :value="code" :disabled="!config.enabled">
              {{ config.name }}
            </option>
          </select>
        </label>
      </footer>
    </nav>

    <button id="mobile_login_drawer_btn" type="button" class="d-none" data-bs-toggle="offcanvas"
      data-bs-target="#loginDrawer"></button>
    <button id="register_btn" type="button" class="d-none" data-bs-toggle="modal" href="#registerModalToggle"></button>
    <register-modal :skin="skin" :language="language" :translation="translation" />
    <jm-account-modals v-if="skin.my_account && skin.my_account.myaccount_type === 'JM'" :language="language"
      :translation="translation" />
    <sharkbet-my-account :skin="skin" />

    <div ref="loginDrawer" class="offcanvas offcanvas-end" tabindex="-1" id="loginDrawer" aria-labelledby="loginDrawerLabel">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title" id="loginDrawerLabel"></h5>
        <button ref="loginDrawerClose" type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas"
          aria-label="Close"></button>
      </div>
      <div class="offcanvas-body">
        <form v-if="user.token === ''" class="sharkbet-drawer-login" @submit.prevent="submitLogin">
          <div class="sharkbet-drawer-login__field">
            <label for="mobile-drawer-user">Nombre de usuario</label>
            <span class="sharkbet-drawer-login__input">
              <i class="fas fa-user-circle"></i>
              <input id="mobile-drawer-user" v-model.trim="username" type="text" autocomplete="username"
                :placeholder="translate('user') || 'Nombre de usuario'">
            </span>
          </div>
          <div class="sharkbet-drawer-login__field">
            <label for="mobile-drawer-password">Contraseña</label>
            <span class="sharkbet-drawer-login__input">
              <i class="fas fa-lock"></i>
              <input id="mobile-drawer-password" v-model="password" :type="showPassword ? 'text' : 'password'"
                autocomplete="current-password" :placeholder="translate('password') || 'Contraseña'">
              <button type="button" class="sharkbet-password-toggle"
                :aria-label="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                @click="showPassword = !showPassword">
                <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </span>
          </div>
          <button class="sharkbet-drawer-login__btn sharkbet-drawer-login__btn--login" type="submit"
            :disabled="loggingIn">{{ loginLabel }}</button>
          <button v-if="skin.register" class="sharkbet-drawer-login__btn sharkbet-drawer-login__btn--register"
            type="button" @click="register">{{ registerLabel }}</button>
          <a class="sharkbet-drawer-login__forgot" href="#" @click.prevent>¿Olvidaste tu contraseña?</a>
          <span v-if="loginError" class="sharkbet-drawer-login__error">{{ loginError }}</span>
        </form>
      </div>
    </div>
  </header>
</template>

<script>
import RegisterModal from './register.vue';
import AccountMenu from './account_menu.vue';
import JmAccountModals from './jm_account_modals.vue';
import SharkbetMyAccount from './my_account.vue';

export default {
  name: 'mainHeaderMobilSharkbet',
  props: ['skin', 'language', 'translation'],
  components: { RegisterModal, AccountMenu, JmAccountModals, SharkbetMyAccount },
  data() {
    return {
      menuOpen: false,
      activeMenu: 'main',
      showAccountDropdown: false,
      username: '',
      password: '',
      showPassword: false,
      loginError: '',
      loggingIn: false,
      refreshingProfile: false,
      profileInterval: null,
    };
  },
  computed: {
    user() { return this.$store.getters['getUserData']; },
    filteredCategories() { return (this.skin.categories || []).filter(category => category.active); },
    formattedBalance() {
      const amount = this.user.user_data?.data?.balance || 0;
      const decimals = this.skin.qBet_config?.decimalsQty || 0;
      return new Intl.NumberFormat('de-DE', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(amount);
    },
    currency() {
      return this.user.user_data?.data?.currency || '';
    },
    formattedGameBonus() {
      return this.formatAmount(this.user.user_data?.data?.balance_bonus ?? this.user.user_data?.data?.bonus ?? 0);
    },
    formattedSportsBonus() {
      return this.formatAmount(this.user.user_data?.data?.balance_frozen ?? this.user.user_data?.data?.frozen ?? 0);
    },
    loginLabel() {
      return this.language === 'es' ? 'Ingresar' : this.language === 'pt' ? 'Entrar' : 'Login';
    },
    registerLabel() {
      return this.language === 'es' ? 'Registro' : this.language === 'pt' ? 'Registro' : 'Register';
    },
  },
  methods: {
    isActive(item) { return this.$store.getters['getInfoRouter']?.url === item.url; },
    formatMenuLabel(label) {
      if (!label) return '';
      return label.charAt(0).toUpperCase() + label.slice(1).toLowerCase();
    },
    changeView(view) {
      const currentView = this.$store.getters['getInfoRouter'];
      const reloadIframe = ['casino', 'casino_live'].includes(view) && currentView?.category === view;

      this.$store.dispatch('changeView', view);

      if (reloadIframe) {
        this.$store.dispatch('setRechargeIframe');
      }
    },
    closeAccountDropdown() { this.showAccountDropdown = false; },
    openLoginDrawer() { document.getElementById('mobile_login_drawer_btn')?.click(); },
    formatAmount(amount) {
      const decimals = this.skin.qBet_config?.decimalsQty || 0;
      return new Intl.NumberFormat('de-DE', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(amount);
    },
    async refreshProfile() {
      if (!this.user.token || this.refreshingProfile) return;

      this.refreshingProfile = true;
      await this.$store.dispatch('getProfile', {
        token: this.user.token,
        site_id: this.user.site_id,
        site: this.user.site,
        prefix: this.user.prefix,
        playerId: this.user.user_data?.data?.user_id,
        source: 'main',
      });
      this.refreshingProfile = false;
    },
    async submitLogin() {
      this.loginError = '';
      if (!this.username || !this.password) { this.loginError = 'Completa usuario y contraseña'; return; }
      this.loggingIn = true;
      const response = await this.$store.dispatch('login', { username: this.username, password: this.password });
      this.loggingIn = false;
      if (response === 'success') {
        this.$refs.loginDrawerClose?.click();
        this.password = '';
        this.$root.$emit('forceRender');
        return;
      }
      this.loginError = response;
    },
    openRegisterModal() { document.getElementById('register_btn')?.click(); },
    register() {
      const drawer = this.$refs.loginDrawer;
      if (!drawer?.classList.contains('show')) {
        this.openRegisterModal();
        return;
      }

      // Bootstrap keeps the drawer focus trap active until its closing transition ends.
      drawer.addEventListener('hidden.bs.offcanvas', this.openRegisterModal, { once: true });
      this.$refs.loginDrawerClose?.click();
    },
    logout() {
      this.showAccountDropdown = false;
      this.$store.dispatch('logOut');
      this.$root.$emit('forceRender');
    },
    changeLanguage(language) { this.$store.dispatch('setLanguage', language); },
    translate(text) {
      if (!text) return '';
      if (this.translation[text]) return this.translation[text][this.language];
      const normalized = text.replace(/ /g, '_');
      return this.translation[normalized]?.[this.language] || text;
    },
  },
  watch: {
    menuOpen() {
      this.$nextTick(() => this.$store.dispatch('setHeaderHeight', this.$el.offsetHeight));
    },
  },
  mounted() {
    this.$store.dispatch('setHeaderHeight', this.$el.offsetHeight);
    document.addEventListener('click', this.closeAccountDropdown);
    this.$root.$on('openLogin', this.openLoginDrawer);
  },
  created() {
    this.profileInterval = setInterval(() => this.refreshProfile(), 8000);
  },
  beforeDestroy() {
    clearInterval(this.profileInterval);
    document.removeEventListener('click', this.closeAccountDropdown);
    this.$root.$off('openLogin', this.openLoginDrawer);
  },
};
</script>

<style scoped>
.sharkbet-mobile-header {
  background: #000;
  color: #fff;
  position: relative;
  z-index: 20;
}

.sharkbet-mobile-header.is-menu-open {
  background: #f4f4f4;
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  inset: 0;
  overflow: visible;
  position: fixed;
  z-index: 1000;
}

.sharkbet-mobile-header__bar {
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  height: 72px;
  padding: 0 15px;
}

.sharkbet-mobile-header.is-menu-open .sharkbet-mobile-header__bar {
  background: #000;
  display: flex;
  flex: 0 0 49px;
  height: 49px;
  justify-content: center;
  padding: 0;
  position: relative;
}

.sharkbet-mobile-header.is-menu-open .sharkbet-mobile-header__menu {
  background: transparent;
  border-radius: 0;
  color: #fff;
  font-size: 20px;
  height: 49px;
  position: absolute;
  right: 12px;
  width: 32px;
}

.sharkbet-mobile-header.is-menu-open .sharkbet-mobile-header__logo {
  height: 40px;
  width: 142px;
}

.sharkbet-mobile-header.is-menu-open .sharkbet-mobile-header__guest,
.sharkbet-mobile-header.is-menu-open .sharkbet-mobile-header__member {
  display: none;
}

.sharkbet-mobile-header__logo {
  background: none;
  border: 0;
  height: 48px;
  justify-self: center;
  padding: 0;
  width: 126px;
}

.sharkbet-mobile-header__logo img {
  height: 100%;
  object-fit: contain;
  width: 100%;
}

.sharkbet-mobile-header__guest,
.sharkbet-mobile-header__member {
  align-items: center;
  display: flex;
  justify-self: end;
}

.sharkbet-mobile-header__guest button,
.sharkbet-mobile-header__member>button {
  align-items: center;
  background: #697077;
  border: 0;
  width: 149px;
  height: 37px;
  border-radius: 24px;
  color: #fff;
  cursor: pointer;
  display: flex;
  font: 700 12px 'Roboto', sans-serif;
  gap: 4px;
  padding: 11px 15px;
  text-transform: none;
  white-space: nowrap;
}

.sharkbet-mobile-header__guest button i,
.sharkbet-mobile-header__member > button i {
  font-size: 22px;
}

.sharkbet-mobile-header__member {
  color: #fff;
  font: 700 12px 'Roboto', sans-serif;
  gap: 6px;
  min-width: 0;
  position: relative;
}

.sharkbet-mobile-header__member>button {
  min-width: 0;
  padding: 10px 12px;
  width: 138px;
}

.sharkbet-mobile-header__member>button span {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sharkbet-mobile-header__account-caret {
  font-size: 10px;
}

.sharkbet-mobile-header__account-dropdown {
  background: #697077;
  border-radius: 5px 5px 5px 5px;
  display: grid;
  overflow: visible;
  position: absolute;
  right: 0;
  top: calc(100% + 16px);
  width: 110px;
  z-index: 30;
}

.sharkbet-mobile-header__account-dropdown::before {
  border-bottom: 8px solid #697077;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  content: '';
  position: absolute;
  right: 15px;
  top: -8px;
}

.sharkbet-mobile-header__account-dropdown button {
  background: transparent;
  border: 0;
  color: #fff;
  cursor: pointer;
  font: 500 16px 'Roboto', sans-serif;
  padding: 12px 16px;
  text-align: left;
}

.sharkbet-mobile-header__account-dropdown button:hover {
  background: #5b6269;
  border-radius: 5px 5px 5px 5px;
}

.sharkbet-mobile-header__menu {
  align-items: center;
  background: #f2f2f2;
  border: 0;
  border-radius: 50%;
  color: #29313a;
  cursor: pointer;
  display: flex;
  font-size: 17px;
  height: 40px;
  justify-content: center;
  justify-self: start;
  padding: 0;
  width: 40px;
}

#loginDrawer {
  background: #000020 !important;
  max-width: 90vw;
  width: 282px !important;
}

#loginDrawer .offcanvas-header {
  justify-content: flex-end;
  padding: 12px 16px 0;
}

#loginDrawer .offcanvas-body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 16px 24px;
}

.sharkbet-drawer-login {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sharkbet-drawer-login__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.sharkbet-drawer-login__field label {
  color: #fff;
  font: 400 16px 'Roboto', sans-serif;
}

.sharkbet-drawer-login__field label::after {
  color: #fff;
  content: ' *';
}

.sharkbet-drawer-login__input {
  align-items: center;
  background: #fff;
  border-radius: 9999px;
  color: #333;
  display: flex;
  height: 40px;
  padding: 0 14px;
}

.sharkbet-drawer-login__input i {
  color: #999;
  flex-shrink: 0;
  font-size: 14px;
}

.sharkbet-drawer-login__input input {
  background: transparent;
  border: 0;
  color: #333;
  font: 14px 'Roboto', sans-serif;
  margin-left: 10px;
  outline: none;
  width: 100%;
}

.sharkbet-drawer-login__input input::placeholder {
  color: #999;
}

.sharkbet-password-toggle {
  background: transparent;
  border: 0;
  color: #999;
  cursor: pointer;
  display: flex;
  margin-left: auto;
  padding: 0;
}

.sharkbet-drawer-login__input .sharkbet-password-toggle {
  color: #999;
}

.sharkbet-drawer-login__btn {
  border: 0;
  border-radius: 25px;
  cursor: pointer;
  font: 600 15px 'Roboto', sans-serif;
  height: 36.5px;
  width: 100%;
}

.sharkbet-drawer-login__btn--login {
  background: #697077;
  color: #fff;
}

.sharkbet-drawer-login__btn--register {
  background: #0092cd;
  color: #fff;
}

.sharkbet-drawer-login__forgot {
  color: rgba(255, 255, 255, .5);
  font: 400 13px 'Roboto', sans-serif;
  margin-top: 4px;
}

.sharkbet-drawer-login__forgot:hover {
  color: #0092cd;
}

.sharkbet-drawer-login__error {
  color: #ff9ea6;
  font-size: 12px;
  text-align: center;
}

.sharkbet-mobile-nav {
  background: #f4f4f4;
  border-top: 1px solid rgba(255, 255, 255, .12);
  display: grid;
}

.sharkbet-mobile-header.is-menu-open .sharkbet-mobile-nav {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}

.sharkbet-mobile-profile {
  background: #0096cc;
  border-radius: 3px;
  color: #fff;
  display: grid;
  margin: 6px;
  padding: 10px 8px 8px;
}

.sharkbet-mobile-profile__identity {
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, .24);
  display: flex;
  font: 600 14px 'Roboto', sans-serif;
  gap: 12px;
  padding: 0 2px 10px;
}

.sharkbet-mobile-profile__identity i {
  font-size: 40px;
}

.sharkbet-mobile-profile__balance-row {
  border-bottom: 1px solid rgba(255, 255, 255, .24);
  display: flex;
  font: 14px 'Roboto', sans-serif;
  justify-content: space-between;
  padding: 6px 2px;
}

.sharkbet-mobile-profile__balance-row strong {
  font-weight: 500;
}

.sharkbet-mobile-profile__refresh {
  align-items: center;
  background: transparent;
  border: 1px solid #fff;
  border-radius: 22px;
  color: #fff;
  cursor: pointer;
  display: flex;
  font: 600 14px 'Roboto', sans-serif;
  gap: 12px;
  height: 37px;
  justify-content: center;
  margin-top: 8px;
}

.sharkbet-mobile-profile__refresh:disabled {
  cursor: wait;
  opacity: .7;
}

.sharkbet-mobile-nav__tabs {
  background: #f4f4f4;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.sharkbet-mobile-nav__tabs--guest {
  grid-template-columns: 1fr;
}

.sharkbet-mobile-nav__tabs button {
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  color: #777;
  cursor: pointer;
  font: 500 14px 'Roboto', sans-serif;
  height: 52px;
}

.sharkbet-mobile-nav__tabs button.is-active {
  border-bottom-color: #0096cc;
  color: #0096cc;
}

.sharkbet-mobile-nav__categories {
  background: #ececec;
  border-top: 9px solid #fff;
  display: grid;
}

.sharkbet-mobile-nav__categories button {
  background: transparent;
  border: 0;
  border-bottom: 1px solid #fff;
  color: #1d252c;
  cursor: pointer;
  font: 700 16px 'Roboto Condensed', 'Roboto', sans-serif;
  min-height: 50px;
  padding: 10px 26px;
  text-align: left;
}

.sharkbet-mobile-nav__categories button.is-active {
  color: #0092cd;
}

.sharkbet-mobile-nav__account {
  background: #ececec;
  border-top: 9px solid #fff;
  padding: 0;
}

.sharkbet-mobile-nav__footer {
  align-items: center;
  background: #000;
  color: #fff;
  display: flex;
  flex: 0 0 55px;
  justify-content: space-between;
  margin-top: auto;
  min-height: 55px;
  padding: 0 14px;
}

.sharkbet-mobile-nav__footer>button {
  background: transparent;
  border: 0;
  color: #fff;
  cursor: pointer;
  font-size: 20px;
  padding: 8px 0;
}

.sharkbet-mobile-nav__language {
  align-items: center;
  display: flex;
  gap: 9px;
}

.sharkbet-mobile-nav__language span {
  height: 20px;
  width: 30px;
}

.sharkbet-mobile-nav__language select {
  appearance: none;
  background: transparent;
  border: 0;
  color: #fff;
  cursor: pointer;
  font: 600 14px 'Roboto', sans-serif;
  max-width: 130px;
  outline: 0;
}

.sharkbet-mobile-nav__language option {
  background: #000;
}

@media (max-width: 600px) {
  .sharkbet-mobile-header:not(.is-menu-open) .sharkbet-mobile-header__bar {
  
    grid-template-columns: clamp(40px, calc(30vw - 54px), 126px) minmax(126px, 1fr) max-content;
  }

  .sharkbet-mobile-header__guest button {
    width: 126px;
  }
}

@media (max-width: 420px) {
  .sharkbet-mobile-header__bar {
    padding: 0 10px;
  }

  .sharkbet-mobile-header__guest button {
    font-size: 10px;
    padding: 10px;
  }

  .sharkbet-mobile-header__guest button i {
    font-size: 17px;
  }

  .sharkbet-mobile-header__member>span {
    display: none;
  }

  .sharkbet-mobile-header__member button {
    width: 126px;
  }
}
</style>
